module.exports = __webpack_public_path__ + "media/images/icon_list_yellow-cdc15859d9ec51f9c89aa9ec50ac2cd4.png";